import {
  HOME_SAVE_SEASON_BEGIN,
  HOME_SAVE_SEASON_SUCCESS,
  HOME_SAVE_SEASON_FAILURE,
  HOME_SAVE_SEASON_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import {makeDictionary} from '../../common/util'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveSeason(season) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_SAVE_SEASON_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      axios.put("/api/seasons", season).then(
        (res) => {
          dispatch({
            type: HOME_SAVE_SEASON_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_SAVE_SEASON_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveSeasonError() {
  return {
    type: HOME_SAVE_SEASON_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SAVE_SEASON_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveSeasonPending: true,
        saveSeasonError: null,
      };

    case HOME_SAVE_SEASON_SUCCESS:
      // The request is success
      return {
        ...state,
        saveSeasonPending: false,
        saveSeasonError: null,
        seasons: makeDictionary(action.data.seasons),
      };

    case HOME_SAVE_SEASON_FAILURE:
      // The request is failed
      return {
        ...state,
        saveSeasonPending: false,
        saveSeasonError: action.data.error,
      };

    case HOME_SAVE_SEASON_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveSeasonError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/saveSeason.js